/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'base-ui/dist/Icon';
import { intl } from 'components/LocaleProvider';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SponsorBox = ({ sponsor }) => (
  <div className="message with-icon grey-bg regent-grey-color">
    <Icon className="icon" prefix="fas" name="info-circle" />
    <span>{`${intl.formatMessage(messages.createdBy)} ${publicRuntimeConfig.blogname} ${intl.formatMessage(messages.sponsoredBy)} ${sponsor}`}</span>
  </div>
);

SponsorBox.propTypes = {
  sponsor: PropTypes.string,
};

export default SponsorBox;
